import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const swiperEl = document.querySelector<HTMLElement>('[data-home-hero-carousel]');
if (swiperEl) {
    const contents = Array.from(swiperEl.querySelectorAll<HTMLElement>('[data-slide-index]'));
    const controls = swiperEl.querySelector('[data-home-hero-controls]') as HTMLElement;

    const autoplayEnabled = swiperEl.getAttribute('data-autoplay') === 'true';
    let autoplaySettings: any = {};
    if (autoplayEnabled) {
        const interval = swiperEl.getAttribute('data-interval') ?? '7000';
        autoplaySettings = {
            autoplay: {
                delay: parseFloat(interval),
                disableOnInteraction: false
            }
        };
    }

    const swiper = new Swiper(swiperEl, {
        modules: [Navigation, Pagination, A11y, Autoplay],
        loop: true,
        ...autoplaySettings,
        navigation: {
            addIcons: false,
            nextEl: '.home-hero-controls .carousel-button-next',
            prevEl: '.home-hero-controls .carousel-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            bulletClass: 'swiper-pagination-bullet carousel-dot',
            bulletActiveClass: 'swiper-pagination-bullet-active carousel-dot-active'
        },
        on: {
            afterInit: () => {
                swiperEl.style.setProperty('--slider-control-width', `${controls?.offsetWidth}px`);
                swiperEl.style.setProperty('--slider-control-height', `${controls?.offsetHeight}px`);
            },
            resize: () => {
                swiperEl.style.setProperty('--slider-control-width', `${controls?.offsetWidth}px`);
                swiperEl.style.setProperty('--slider-control-height', `${controls?.offsetHeight}px`);
            }
        }
    });

    swiper.on('slideChange', () => {
        const realIndex = swiper.realIndex;
        contents.forEach((el) => {
            const elIndex = el.getAttribute('data-slide-index');
            if (elIndex == realIndex) {
                el.classList.add('is-active');
                el.inert = false;
            }
            else {
                el.classList.remove('is-active');
                el.inert = true;
            }
        });
    });

    if (autoplayEnabled) {
        const pauseButton = swiperEl.querySelector<HTMLButtonElement>('[data-carousel-pause]');
        pauseButton?.addEventListener('click', () => {
            if (swiper.autoplay.running) {
                swiper.autoplay.stop();
                pauseButton.setAttribute('aria-pressed', 'true');
            }
            else {
                swiper.autoplay.start();
                pauseButton.setAttribute('aria-pressed', 'false');
            }
        });
    }
}